import BenefitsSection from '@/v2/components/sections/common/benefits-section'
import FaqSection from '@/v2/components/sections/common/faq-section'
import ForWhoSection from '@/v2/components/sections/common/for-who-section'
import HeroSection from '@/v2/components/sections/common/hero-section'
import PromotionalBannerSection from '@/v2/components/sections/common/promotional-banner-section'
import ServiceTipsSection from '@/v2/components/sections/common/service-tips-section'
import WhyWeSection from '@/v2/components/sections/common/why-we-section'

import {
  benefitsSectionContent,
  faqSectionContent,
  forWhoSectionContent,
  heroSectionContent,
  promotionalBannerSectionContent,
  SchoolPickUpAndDeliverySectionContent,
  serviceTipsSectionContent,
  whyWeSectionContent
} from '@/v2/constants/pages/public-pages/college-student-shipping-page'

interface CollegeStudentShippingPageProps {}

const CollegeStudentShippingPage: React.FC<CollegeStudentShippingPageProps> = () => {
  return (
    <>
      <HeroSection
        {...heroSectionContent}
        imgClassName=' 
        w-[282px] h-[197px] 
        md-mn:w-[340px] md-mn:h-[237px] 
        lg:!w-[492px] lg:!h-[343px] 
        xl-min:!w-[680px] xl-min:!h-[458px]
      '
        btnClassName='xl-min:!w-[269px] xl-min:!h-[50px] md-mn:w-[240px] w-[278px] h-[44px]'
      />
      <WhyWeSection
        isBgDark
        {...whyWeSectionContent}
        className={`xl-min:[&_button]:!w-[254px] [&_button]:w-[278px]
        `}
      />
      <ServiceTipsSection
        {...serviceTipsSectionContent}
        sectionTitleClassName='md-mn:w-full md-mn:[&_p]:w-full [&_p]:w-[90%]'
        className='lg-mn:[&>div>div:nth-of-type(2)]:grid-cols-2 xl-min:[&>div>div:nth-of-type(2)]:!grid-cols-3'
      />
      <BenefitsSection isBgDark {...benefitsSectionContent} className='md-mn:[&_article]:flex-row' />
      <ForWhoSection {...forWhoSectionContent} className='md-mn:[&>div>div:nth-of-type(2)]:gap-6' />
      <WhyWeSection
        isBgDark
        {...SchoolPickUpAndDeliverySectionContent}
        className='[&_article]:bg-transparent [&_article]:border-none'
      />
      <PromotionalBannerSection
        card={promotionalBannerSectionContent}
        ctaButton={promotionalBannerSectionContent.ctaButton}
        imgClassName='xl-min:!w-[420px] xl-min:!h-[295px] md-mn:w-[311.71px] md-mn:h-[219px] w-[232px] h-[163px]'
        className='xl-min:[&_article_button]:!w-[275px] md-mn:[&_article_button]:w-[254px] [&_article_button]:w-[248px]'
      />
      <FaqSection isBgDark {...faqSectionContent} />
    </>
  )
}

export default CollegeStudentShippingPage
